export default {
  setShowDepoAccessDenied(state, payload) {
    state.showDepoAccessDenied = payload;
  },
  addActiveAjax(state, payload) {
    state.activeAjax.push(payload);
  },
  clearActiveAjax(state, cb) {
    state.activeAjax.forEach((ajax) => {
      ajax.cancel('Request aborted');
    });
    state.activeAjax = [];
    if (cb && typeof cb === 'function') {
      cb();
    }
  },
  setTourState(state, payload) {
    state.tourState = payload;
  },
  setObjIsLoading(state, payload) {
    state.objIsLoading = payload;
  },
  xhrActiveNumAdd(state) {
    state.xhrActiveNum += 1;
  },
  xhrActiveNumRem(state) {
    state.xhrActiveNum = (state.xhrActiveNum > 0 ? state.xhrActiveNum - 1 : 0);
  },
};



// WEBPACK FOOTER //
// ./src/store/mutations.js